export default "__VITE_ASSET__CQiCoL71__"